// extracted by mini-css-extract-plugin
export default {"App":"videosFaq_App__a-KRB","container":"videosFaq_container__IU0+D"};